module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-popconfirm', _vm._g(_vm._b({}, 'el-popconfirm', _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._t("reference", null, {
    "slot": "reference"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a2a51a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/popconfirm/rtPopconfirm.vue
// module id = 2012
// module chunks = 228